<template>
  <div>
    <div class="controls">
      <div class="control-group">
        <label for="mode-selector">Mode</label>
        <select id="mode-selector" v-model="mode">
          <option value="">Default</option>
          <option value="hide">Hide incorrect tiles</option>
          <option value="transparentize">Transparentize incorrect tiles</option>
          <option value="outline">Outline incorrect tiles</option>
        </select>
      </div>

      <div class="control-group">
        <label>Actions</label>
        <button type="button" class="btn--cancel" @click="$emit('resolve')">Resolve</button>
        <button type="button" class="btn--cancel" @click="$emit('reset')">Reset</button>
        <button type="button" class="btn--cancel" @click="displayPositions">Positions</button>
        <button type="button" class="btn--cancel" @click="showPositionsInput=true">Load positions</button>
      </div>
    </div>

    <div v-if="showPositionsInput" class="modal-wrapper">
      <div class="modal">
        <h2>Paste a grid configuration</h2>
        <div v-if="loadPositionsError" class="info info--error">Invalid positions</div>
        <textarea v-model="positionsInput" name="positions" />

        <div class="modal-footer">
          <button type="button" class="btn--cancel" @click="showPositionsInput = false">Cancel</button>
          <button type="button" @click="applyPositions">Load</button>
        </div>
      </div>
    </div>

    <div v-if="showPositions" class="modal-wrapper">
      <div class="modal">
        <h2>Copy this somewhere if you want to save your state</h2>
        <div class="positions-block">
          <small><code>{{ currentPositions }}</code></small>
        </div>

        <div class="modal-footer">
          <button type="button" @click="showPositions=false">Close</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'JigsawControls',
  props: { game: { required: true, type: Object } },
  data () {
    return {
      mode: '',
      showPositionsInput: false,
      loadPositionsError: false,
      currentPositions: null,
      showPositions: false,
      positionsInput: '',
    }
  },
  methods: {
    displayPositions () {
      this.currentPositions = JSON.stringify(this.game.currentPlacement())
      this.showPositions = true
    },

    applyPositions () {
      if (!this.positionsInput) return
      this.loadPositionsError = false

      try {
        const positions = JSON.parse(this.positionsInput)
        this.game.loadPlacement(positions)
        this.showPositionsInput = false
      } catch (e) {
        this.loadPositionsError = true
      }
    },
  },
  watch: {
    mode (newValue) {
      this.$emit('mode', newValue)
    },
  },
}
</script>
